module.exports = __webpack_public_path__ + "img/coins-2.dd55ef2f.png";